import { Injectable } from '@angular/core';
import {
  Subject,
  fromEvent,
  merge,
  Observable
} from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InteractivityService {

  interaction$ = new Subject<Event>();
  noInteraction$ = new Subject<void>();

  hasModalOpened = false;

  private interval = 1000;
  private timeOut!: ReturnType<typeof setTimeout>;

  private interactionEvents$ = merge(
    fromEvent(document, 'click'),
    fromEvent(document, 'keydown'),
    fromEvent(document, 'keyup'),
    fromEvent(document, 'mousemove'),
    fromEvent(document, 'scroll')
  ).pipe(debounceTime(250));

  setupInactivityTimer(interval?: number): Observable<void> {
    this.interval = interval || 1000;
    this.setUpTimer();

    return this.interactionEvents$.pipe(
      map((event: Event) => {
        this.interaction$.next(event);
        this.setUpTimer();
      })
    );
  }

  private setUpTimer() {
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      this.noInteraction$.next();
    }, this.interval);
  }
}
